export class Constants {
  static HIT_POSITION_RATIO = 4; // the large vs small hit position size
  static BALL_SIZE: number = 42; // the ball size
  static X_CENTER: number = 1190; // the centre of the ball on the y axis
  static Y_CENTER: number = 433; // the x axis table centre
}